export const latestTicker = [
  { id: "lin-qingyue-candidate-bird-signal", title: "林清越新专辑《候鸟信号》凌晨上线，无预热直接发" },
  { id: "film-dawn-city-review", title: "《破晓之城》点映口碑出炉，观众坐到了字幕结束" },
  { id: "variety-slow-life-season-3", title: "《慢慢来》第三季开播，摄制组缩减近一半" },
  { id: "su-han-red-carpet-wardrobe", title: "苏晗红毯礼服修改三十次，造型团队公开幕后" },
  { id: "overseas-lumen-park-renewed", title: "《暗涌公园》确认续订第二季，时间线跳跃三年" },
  { id: "livehouse-tour-rising", title: "独立音乐人集体回归 Livehouse，小场地巡演升温" },
];